var animationDuration = {
  /** 100 */
  fastest: 100,
  /** 150 */
  faster: 150,
  /** 200 */
  fast: 200,
  /** 300 */
  standard: 300,
  /** 400 */
  slow: 400,
  /** 450 */
  slower: 450,
  /** 500 */
  slowest: 500
};

export { animationDuration };
